import {Component, OnInit} from '@angular/core';
import {Skill} from './my-skill/skill.model';

@Component({
  selector: 'app-professional',
  templateUrl: './professional.component.html',
  styleUrls: ['./professional.component.css']
})
export class ProfessionalComponent implements OnInit {

  skills: Skill[] = [new Skill('Java', '95%'), new Skill('PHP', '95%'), new Skill('JSP', '95%'), new Skill('JavaScript', '80%'),
    new Skill('Angular', '80%'), new Skill('MySQL', '80%'), new Skill('SQL', '80%'), new Skill('HTML & CSS', '90%'),
    new Skill('REDCap', '99%')];

  constructor() {
  }

  ngOnInit() {
    this.skills.sort((a, b) => a.name.localeCompare(b.name));
  }

}
